import { render } from "./DiskOfferingSelection.vue?vue&type=template&id=7243029c&scoped=true"
import script from "./DiskOfferingSelection.vue?vue&type=script&lang=js"
export * from "./DiskOfferingSelection.vue?vue&type=script&lang=js"

import "./DiskOfferingSelection.vue?vue&type=style&index=0&id=7243029c&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7243029c"]])

export default __exports__